import { ReactComponent as AboutUs } from '../../assets/svgs/AboutUsIcon.svg';
import { ReactComponent as AccountBalanceWallet } from '../../assets/svgs/AccountBalanceWallet.svg';
import { ReactComponent as Activity } from '../../assets/svgs/ActivityIcon.svg';
import { ReactComponent as Admin } from '../../assets/svgs/AdminIcon.svg';
import { ReactComponent as AlarmClock } from '../../assets/svgs/AlarmClock.svg';
import { ReactComponent as Answer } from '../../assets/svgs/AnswerIcon.svg';
import { ReactComponent as ArrowLeft } from '../../assets/svgs/ArrowLeftIcon.svg';
import { ReactComponent as ArrowRightFill } from '../../assets/svgs/ArrowRightFillIcon.svg';
import { ReactComponent as ArrowRight } from '../../assets/svgs/ArrowRightIcon.svg';
import { ReactComponent as Assistant } from '../../assets/svgs/Assistant.svg';
import { ReactComponent as Book } from '../../assets/svgs/Book.svg';
import { ReactComponent as BookDonation } from '../../assets/svgs/BookDonation.svg';
import { ReactComponent as BookmarkIcon } from '../../assets/svgs/Bookmark.svg';
import { ReactComponent as BookPairsDecor } from '../../assets/svgs/BookPairsDecor.svg';
import { ReactComponent as CalendarIcon } from '../../assets/svgs/CalendarIcon.svg';
import { ReactComponent as CalendarIconWhite } from '../../assets/svgs/CalendarWhite.svg';
import { ReactComponent as Camera } from '../../assets/svgs/CameraIcon.svg';
import { ReactComponent as CheckIcon } from '../../assets/svgs/CheckIcon.svg';
import { ReactComponent as Checkmark } from '../../assets/svgs/CheckmarkIcon.svg';
import { ReactComponent as ChevronDown } from '../../assets/svgs/ChevronDownIcon.svg';
import { ReactComponent as Chevron } from '../../assets/svgs/ChevronIcon.svg';
import { ReactComponent as ChevronLeft } from '../../assets/svgs/ChevronLeftIcon.svg';
import { ReactComponent as ChevronRight } from '../../assets/svgs/ChevronRightIcon.svg';
import { ReactComponent as ChevronUp } from '../../assets/svgs/ChevronUpIcon.svg';
import { ReactComponent as ClipboardIcon } from '../../assets/svgs/ClipboardIcon.svg';
import { ReactComponent as Clock } from '../../assets/svgs/ClockIcon.svg';
import { ReactComponent as CloseIcon } from '../../assets/svgs/CloseIcon.svg';
import { ReactComponent as CloseIconSnackbar } from '../../assets/svgs/CloseIconSnackbar.svg';
import { ReactComponent as CloseQuote } from '../../assets/svgs/CloseQuoteIcon.svg';
import { ReactComponent as CollectionsBookmark } from '../../assets/svgs/CollectionsBookmark.svg';
import { ReactComponent as CommunicationIcon } from '../../assets/svgs/Communication.svg';
import { ReactComponent as ContentPaste } from '../../assets/svgs/ContentPasteIcon.svg';
import { ReactComponent as Copy } from '../../assets/svgs/CopyIcon.svg';
import { ReactComponent as CorrectTotal } from '../../assets/svgs/CorrectTotalIcon.svg';
import { ReactComponent as Dehaze } from '../../assets/svgs/Dehaze.svg';
import { ReactComponent as Delete } from '../../assets/svgs/DeleteIcon.svg';
import { ReactComponent as DeleteIconSnackbar } from '../../assets/svgs/DeleteIconSnackbar.svg';
import { ReactComponent as DeleteModalIcon } from '../../assets/svgs/DeleteModalIcon.svg';
import { ReactComponent as DescriptionIcon } from '../../assets/svgs/DescriptionIcon.svg';
import { ReactComponent as DevelopmentIcon } from '../../assets/svgs/DevelopmentIcon.svg';
import { ReactComponent as Document } from '../../assets/svgs/DocumentIcon.svg';
import { ReactComponent as DocumentPageIcon } from '../../assets/svgs/DocumentPageIcon.svg';
import { ReactComponent as DoneAll } from '../../assets/svgs/DoneAllIcon.svg';
import { ReactComponent as Download } from '../../assets/svgs/DownloadIcon.svg';
import { ReactComponent as Edit } from '../../assets/svgs/EditIcon.svg';
import { ReactComponent as EditPen } from '../../assets/svgs/EditPen.svg';
import { ReactComponent as EducationHat } from '../../assets/svgs/EducationHatIcon.svg';
import { ReactComponent as EqualizerIcon } from '../../assets/svgs/EqualizerIcon.svg';
import { ReactComponent as Exercise } from '../../assets/svgs/ExerciseIcon.svg';
import { ReactComponent as FacebookIcon } from '../../assets/svgs/FacebookIcon.svg';
import { ReactComponent as LogoFessior } from '../../assets/svgs/FessiorLogo.svg';
import { ReactComponent as FileInvoiceWhite } from '../../assets/svgs/FileInvoiceWhite.svg';
import { ReactComponent as FilterIcon } from '../../assets/svgs/FilterIcon.svg';
import { ReactComponent as FiveWingStarIcon } from '../../assets/svgs/FiveSwingStarIcon.svg';
import { ReactComponent as LogoGoogle } from '../../assets/svgs/GoogleIcon.svg';
import { ReactComponent as Help } from '../../assets/svgs/HelpIcon.svg';
import { ReactComponent as Home } from '../../assets/svgs/HomeIcon.svg';
import { ReactComponent as Introduction } from '../../assets/svgs/IntroductionIcon.svg';
import { ReactComponent as IpodWhite } from '../../assets/svgs/IpodWhite.svg';
import { ReactComponent as Library } from '../../assets/svgs/LibraryIcon.svg';
import { ReactComponent as List } from '../../assets/svgs/ListIcon.svg';
import { ReactComponent as LiveHelpIcon } from '../../assets/svgs/LiveHelpIcon.svg';
import { ReactComponent as LocationCity } from '../../assets/svgs/LocationCity.svg';
import { ReactComponent as LocationIcon } from '../../assets/svgs/LocationIcon.svg';
import { ReactComponent as LocationPin } from '../../assets/svgs/LocationPin.svg';
import { ReactComponent as LocationTransparent } from '../../assets/svgs/LocationTransparent.svg';
import { ReactComponent as LogoCTCT } from '../../assets/svgs/LogoCTCT.svg';
import { ReactComponent as LogoCTCTNoText } from '../../assets/svgs/LogoCTCTNoText.svg';
import { ReactComponent as LogoDiscord } from '../../assets/svgs/LogoDiscord.svg';
import { ReactComponent as LogoFacebook } from '../../assets/svgs/LogoFacebook.svg';
import { ReactComponent as LogoFacebookBlue } from '../../assets/svgs/LogoFacebookBlue.svg';
import { ReactComponent as LogoGDSC } from '../../assets/svgs/LogoGDSC.svg';
import { ReactComponent as LogoGDSCHorizontal } from '../../assets/svgs/LogoGDSCHorizontal.svg';
import { ReactComponent as LogoGmail } from '../../assets/svgs/LogoGmail.svg';
import { ReactComponent as LogoLinkedin } from '../../assets/svgs/LogoLinkedin.svg';
import { ReactComponent as Logout } from '../../assets/svgs/LogoutIcon.svg';
import { ReactComponent as LogoYoutube } from '../../assets/svgs/LogoYoutube.svg';
import { ReactComponent as MailIcon } from '../../assets/svgs/MailIcon.svg';
import { ReactComponent as MenuListIcon } from '../../assets/svgs/MenuList.svg';
import { ReactComponent as MockTestIcon } from '../../assets/svgs/MockTestIcon.svg';
import { ReactComponent as MoreVerticalIcon } from '../../assets/svgs/MoreVertical.svg';
import { ReactComponent as NoBookFound } from '../../assets/svgs/NoBookFoundIcon.svg';
import { ReactComponent as NotebookDecor } from '../../assets/svgs/NotebookDecor.svg';
import { ReactComponent as OpenAside } from '../../assets/svgs/OpenAsideIcon.svg';
import { ReactComponent as OpenBookDecor } from '../../assets/svgs/OpenBookDecor.svg';
import { ReactComponent as OpenBook } from '../../assets/svgs/OpenBookIcon.svg';
import { ReactComponent as OpenQuote } from '../../assets/svgs/OpenQuoteIcon.svg';
import { ReactComponent as OriginIcon } from '../../assets/svgs/OriginIcon.svg';
import { ReactComponent as Partner } from '../../assets/svgs/PartnerIcon.svg';
import { ReactComponent as Pen } from '../../assets/svgs/PenIcon.svg';
import { ReactComponent as PhoneIcon } from '../../assets/svgs/PhoneIcon.svg';
import { ReactComponent as PieChart } from '../../assets/svgs/PieChartIcon.svg';
import { ReactComponent as Profile } from '../../assets/svgs/ProfileIcon.svg';
import { ReactComponent as Quiz } from '../../assets/svgs/QuizIcon.svg';
import { ReactComponent as Result } from '../../assets/svgs/ResultIcon.svg';
import { ReactComponent as Retry } from '../../assets/svgs/RetryIcon.svg';
import { ReactComponent as Room } from '../../assets/svgs/RoomIcon.svg';
import { ReactComponent as Search } from '../../assets/svgs/SearchIcon.svg';
import { ReactComponent as Send } from '../../assets/svgs/SendIcon.svg';
import { ReactComponent as Share } from '../../assets/svgs/ShareIcon.svg';
import { ReactComponent as StackBooksDecor } from '../../assets/svgs/StackBooksDecor.svg';
import { ReactComponent as StarDim } from '../../assets/svgs/StarDimIcon.svg';
import { ReactComponent as AssistantStar } from '../../assets/svgs/StarIcon.svg';
import { ReactComponent as StarLit } from '../../assets/svgs/StarLitIcon.svg';
import { ReactComponent as Subject } from '../../assets/svgs/SubjectIcon.svg';
import { ReactComponent as Test } from '../../assets/svgs/TestIcon.svg';
import { ReactComponent as Tune } from '../../assets/svgs/TuneIcon.svg';
import { ReactComponent as Upload } from '../../assets/svgs/UploadIcon.svg';
import { ReactComponent as UpRightArrowIcon } from '../../assets/svgs/UpRightArrowIcon.svg';
import { ReactComponent as UserAnswer } from '../../assets/svgs/UserAnswerIcon.svg';
import { ReactComponent as Video } from '../../assets/svgs/Video.svg';
import { ReactComponent as ViewIcon } from '../../assets/svgs/ViewIcon.svg';
import { ReactComponent as XMark } from '../../assets/svgs/XMarkIcon.svg';
import { ReactComponent as YoutubeIcon } from '../../assets/svgs/YoutubeIcon.svg';
import { ReactComponent as ZoomInIcon } from '../../assets/svgs/ZoomInIcon.svg';
import { ReactComponent as ZoomOutIcon } from '../../assets/svgs/ZoomOutIcon.svg';

export default {
  AboutUs,
  Activity,
  AccountBalanceWallet,
  Admin,
  AlarmClock,
  Answer,
  ArrowLeft,
  ArrowRightFill,
  ArrowRight,
  Assistant,
  AssistantStar,
  BookDonation,
  BookPairsDecor,
  BookmarkIcon,
  CalendarIcon,
  Camera,
  CheckIcon,
  Checkmark,
  Chevron,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Clock,
  CloseIcon,
  CommunicationIcon,
  ContentPaste,
  Book,
  ChevronUp,
  ClipboardIcon,
  CloseIconSnackbar,
  Copy,
  CollectionsBookmark,
  Dehaze,
  Delete,
  DeleteModalIcon,
  DescriptionIcon,
  DeleteIconSnackbar,
  Download,
  LogoLinkedin,
  DevelopmentIcon,
  Document,
  DocumentPageIcon,
  Edit,
  EditPen,
  EducationHat,
  EqualizerIcon,
  FacebookIcon,
  FilterIcon,
  FiveWingStarIcon,
  LocationIcon,
  LocationTransparent,
  LocationPin,
  LogoCTCT,
  LogoCTCTNoText,
  LogoFacebookBlue,
  LogoGDSC,
  LogoGDSCHorizontal,
  LogoGoogle,
  LogoFessior,
  LogoYoutube,
  Exercise,
  PhoneIcon,
  List,
  MailIcon,
  MenuListIcon,
  MockTestIcon,
  MoreVerticalIcon,
  NotebookDecor,
  Help,
  Home,
  Introduction,
  Library,
  Logout,
  Partner,
  Quiz,
  OriginIcon,
  OpenAside,
  OpenBook,
  OpenBookDecor,
  OpenQuote,
  DoneAll,
  CloseQuote,
  UserAnswer,
  Result,
  Room,
  Search,
  Share,
  Send,
  StackBooksDecor,
  StarLit,
  Subject,
  PieChart,
  CorrectTotal,
  StarDim,
  Test,
  Profile,
  Retry,
  Upload,
  ViewIcon,
  XMark,
  LogoGmail,
  LogoFacebook,
  LogoDiscord,
  Pen,
  YoutubeIcon,
  ZoomInIcon,
  ZoomOutIcon,
  UpRightArrowIcon,
  LiveHelpIcon,
  FileInvoiceWhite,
  CalendarIconWhite,
  IpodWhite,
  LocationCity,
  Tune,
  NoBookFound,
  Video,
};
